<template>
  <section>
    <div class="guests-page__head" style="margin: 0 0 14px">
      <div>
        <h2 class="guests-page__title" style="font-size: 18px">
          Cataloghi CSV
        </h2>
        <p class="guests-page__subtitle">
          Aggiorna i cataloghi di riferimento caricando i file CSV. Il file
          viene inviato al server, che esegue l'import (idempotente).
        </p>
      </div>
    </div>

    <div v-if="loading" class="guests-loading">Caricamento…</div>

    <div v-else class="guest-detail" style="max-width: 720px">
      <h3 class="detail-block-title">
        <i class="fa-solid fa-pills"></i> Catalogo farmaci AIFA
      </h3>

      <div class="tpl-info" style="margin-bottom: 16px">
        <i class="fa-solid fa-circle-info"></i>
        Record attuali in catalogo: <strong>{{ aifa.recordCount }}</strong>
        <template v-if="lastImport">
          · Ultimo import:
          <strong>{{ statusLabel(lastImport.status) }}</strong>
          il {{ fmtDate(lastImport.completedAt) }} (nuovi
          {{ lastImport.importedCount }}, aggiornati
          {{ lastImport.updatedCount }}, saltati {{ lastImport.skippedCount }})
        </template>
        <template v-else>· Nessun import registrato.</template>
      </div>

      <div class="form-grid">
        <div class="form-field form-field--full">
          <label
            >Anagrafica AIFA (anagrafica_aifa.csv)
            <span class="required">*</span></label
          >
          <input ref="anagrafica" type="file" accept=".csv,text/csv" />
        </div>
        <div class="form-field form-field--full">
          <label>Principi attivi (principi_attivi.csv)</label>
          <input ref="principi" type="file" accept=".csv,text/csv" />
        </div>
        <div class="form-field form-field--full">
          <label>ATC (anagrafica_atc.csv) — opzionale</label>
          <input ref="atc" type="file" accept=".csv,text/csv" />
        </div>
      </div>

      <div class="form-actions">
        <button
          class="villa-btn villa-btn--primary"
          :disabled="importing"
          @click="runImport"
        >
          <i
            :class="
              importing
                ? 'fa-solid fa-spinner fa-spin'
                : 'fa-solid fa-cloud-arrow-up'
            "
          ></i>
          {{ importing ? "Import in corso…" : "Importa / Aggiorna catalogo" }}
        </button>
      </div>

      <div v-if="result" class="tpl-info" style="margin-top: 14px">
        <strong>Riepilogo import:</strong>
        righe lette {{ result.read }} · nuove {{ result.imported }} · aggiornate
        {{ result.updated }} · saltate {{ result.skipped }} · errori
        {{ result.errors }}.
        <div
          v-if="result.warnings && result.warnings.length"
          style="margin-top: 6px"
        >
          <em>{{ result.warnings.length }} avvisi (prime righe saltate).</em>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CatalogImportPanel",
  data() {
    return {
      loading: true,
      importing: false,
      aifa: { recordCount: 0, lastImport: null },
      result: null,
    };
  },
  computed: {
    lastImport() {
      return this.aifa.lastImport;
    },
  },
  methods: {
    ...mapActions(["fetchCatalogs", "importAifaCatalog"]),
    statusLabel(s) {
      return { completed: "completato", failed: "fallito" }[s] || s;
    },
    fmtDate(d) {
      if (!d) return "—";
      const dt = new Date(d);
      if (Number.isNaN(dt.getTime())) return "—";
      const p = (n) => String(n).padStart(2, "0");
      return `${p(dt.getDate())}/${p(
        dt.getMonth() + 1
      )}/${dt.getFullYear()} ${p(dt.getHours())}:${p(dt.getMinutes())}`;
    },
    async load() {
      this.loading = true;
      try {
        const catalogs = await this.fetchCatalogs();
        const aifa = catalogs.find((c) => c.catalogType === "aifa");
        if (aifa) this.aifa = aifa;
      } catch (err) {
        this.$toast.error(
          err?.response?.data?.message || "Caricamento cataloghi non riuscito."
        );
      } finally {
        this.loading = false;
      }
    },
    async runImport() {
      const anagrafica = this.$refs.anagrafica?.files?.[0];
      if (!anagrafica) {
        return this.$toast.error("Seleziona almeno il file anagrafica AIFA.");
      }
      const formData = new FormData();
      formData.append("anagrafica", anagrafica, anagrafica.name);
      const principi = this.$refs.principi?.files?.[0];
      if (principi) formData.append("principi", principi, principi.name);
      const atc = this.$refs.atc?.files?.[0];
      if (atc) formData.append("atc", atc, atc.name);

      this.importing = true;
      this.result = null;
      try {
        const data = await this.importAifaCatalog(formData);
        this.result = data.summary;
        this.$toast.success("Catalogo AIFA aggiornato.");
        await this.load();
      } catch (err) {
        this.$toast.error(
          err?.response?.data?.message || "Import non riuscito."
        );
      } finally {
        this.importing = false;
      }
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style src="@/css/GuestsPage.css" />
